import { TextField } from "../types";
import { noWhitespacesValidation, translate } from "@kaltura/mediaspace-shared-utils";
import { FieldError, useFormContext } from "react-hook-form";
import React from "react";
import { styled } from "@mui/material";
import { baseInputClasses } from "@kaltura/ds-react-components";
import { TextField as TextFiledInput } from "@kaltura/mediaspace-shared-ui/controlled-form";
import { FormFieldError } from "@kaltura/mediaspace-shared-ui/form";

export interface TextFieldProps {
    field: TextField;
}

export const Text = ({ field }: TextFieldProps) => {
    const { label, id, required, disabled } = field;

    const {
        register,
        formState: { errors },
    } = useFormContext();
    //
    const error = errors[id];
    const errorMessage = error?.type === "required" ? translate("Field %1 is required", [label]) : "";

    return (
        <>
            <StyledTextInput
                id={id}
                {...register(
                    field.id,
                    noWhitespacesValidation({
                        required: required,
                    })
                )}
                key={id}
                label={label}
                required={required}
                fontWeightBold={true}
                error={errors[id] as FieldError}
                errorMessage={errorMessage}
                readonly={disabled}
            />
            <div aria-live="polite">{errorMessage && <FormFieldError>{errorMessage}</FormFieldError>}</div>
        </>
    );
};

const StyledTextInput = styled(TextFiledInput)(({ theme }) => ({
    [`& .${baseInputClasses.root}.${baseInputClasses.readOnly}`]: {
        borderColor: theme.kaltura.palette.tone4,
    },
}));
